import React, { ComponentProps } from "react";
import * as S from "./styles";

interface ITextAreaProps extends ComponentProps<"textarea"> {
  label?: string;
}
export const TextArea = React.forwardRef<HTMLTextAreaElement, ITextAreaProps>(
  ({ label, ...rest }: ITextAreaProps, ref) => {
    return (
      <S.Label>
        {label && <span>{label}</span>}
        <S.MyTextArea {...rest} ref={ref} />
      </S.Label>
    );
  }
);
